import { render } from "./vbalanceredpacket.vue?vue&type=template&id=189f764f&scoped=true"
import script from "./vbalanceredpacket.vue?vue&type=script&lang=js"
export * from "./vbalanceredpacket.vue?vue&type=script&lang=js"

import "./vbalanceredpacket.vue?vue&type=style&index=0&id=189f764f&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189f764f"]])

export default __exports__